import { Injectable } from "@angular/core";
import { HttpProvider } from "../http/http";
import { BaseConfigProvider } from "../base-config/base-config";
import { global } from "../../environments/global";

/*
  Generated class for the HomeProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class HomeProvider {
  constructor(public http: HttpProvider) {
    console.log("Hello HomeProvider Provider");
  }

  getRobotList() {
    return this.http.hPost("/robot/get_list");
  }

  verifyCode(code) {

    return this.http.verifyCode(code);
  }

  getBotQR() {
  }

  getBotInfo() {
    return this.http.hPost("/user/get_user_basic_info");
  }

  setBotName(bot_id, bot_name) {
    let params = {
      bot_id: bot_id,
      bot_nickname: bot_name
    };
    return this.http.hPost("/robot/set_robot_nickname", params);
  }

  initBot(bot_name) {
    let params = {
      bot_nickname: bot_name
    };
    return this.http.hPost("/initial_robot_nickname", params);
  }

  sendSms(phone) {
    return this.http.hPost("/login/send_sms", { phone: phone, app_name: global.app_name_real });
  }

  verifyPhone(phone, code, open_id?, inviter_open_id?) {
    let params = {
      phone: phone,
      sms_code: code,
      app_name: global.app_name_real,
      open_id: open_id,
      inviter_open_id: inviter_open_id
    };
    return this.http.hPost("/login/phone_login", params);
  }

  getBasicUserInfo() {
    return this.http.hPost("/user/get_user_basic_info", { app_name: global.app_name_real });
  }

  getLineData() {
    return this.http.hPost("/clientchatroom/get_chatroom_30_day_data");
  }

  getTop3Chatroom() {
    return this.http.hPost("/clientchatroom/in_out_top3_chatroom");
  }

  needCode() {
    return this.http.hPost("/user/need_code");
  }

  needIntro() {
    return this.http.hPost("/robot/need_intro");
  }

}



// WEBPACK FOOTER //
// ./src/providers/home/home.ts